{
  "brand": "Aruba Animal Radar",
  "tagline": "Dossiers van straatanimalen — waarnemingen, vermiste huisdieren, chips.",
  "nav": {
    "map": "Kaart",
    "addSighting": "Waarneming toevoegen",
    "reportLost": "Vermist melden",
    "searchChip": "Chip zoeken",
    "login": "Inloggen",
    "logout": "Uitloggen"
  },
  "panel": {
    "title": "Actieve zaken",
    "lostTitle": "Momenteel vermist",
    "emptyLost": "Geen actieve vermissingen.",
    "openPanel": "Dossiers",
    "closePanel": "Sluiten",
    "sightings": "Waarnemingen",
    "related": "Gekoppelde waarnemingen",
    "stepPrev": "Vorige waarneming",
    "stepNext": "Volgende waarneming"
  },
  "fields": {
    "type": "Type",
    "breed": "Ras",
    "color1": "Primaire kleur",
    "color2": "Secundaire kleur",
    "color3": "Derde kleur",
    "chip": "Microchip",
    "spayed": "Gesteriliseerd / Gecastreerd",
    "ownership": "Eigendomsstatus",
    "ifFound": "Indien gevonden, contact",
    "notes": "Notities",
    "location": "Locatie",
    "sightedAt": "Gezien op",
    "contact": "Contactgegevens",
    "unknown": "Onbekend",
    "none": "Geen",
    "other": "Anders"
  },
  "types": {
    "dog": "Hond",
    "cat": "Kat",
    "other": "Anders"
  },
  "colors": {
    "black": "Zwart",
    "white": "Wit",
    "brown_chocolate": "Bruin / Chocolade",
    "tan_fawn": "Tan / Fawn",
    "red_orange": "Rood / Oranje",
    "gray_blue": "Grijs / Blauw",
    "cream_yellow": "Crème / Geel",
    "gold_apricot": "Goud / Abrikoos"
  },
  "ownership": {
    "confirmed_owned": "Bevestigd eigendom",
    "confirmed_abandoned": "Bevestigd achtergelaten",
    "no_known_owner": "Geen bekende eigenaar",
    "reported_lost": "Als vermist gemeld"
  },
  "spayed": {
    "yes": "Ja",
    "no": "Nee",
    "unknown": "Onbekend"
  },
  "actions": {
    "submit": "Verzenden",
    "cancel": "Annuleren",
    "search": "Zoeken",
    "link": "Waarnemingen koppelen",
    "unlink": "Ontkoppelen van dier",
    "save": "Opslaan",
    "pickOnMap": "Kies op de kaart"
  },
  "forms": {
    "addSightingTitle": "Waarneming registreren",
    "reportLostTitle": "Vermist huisdier melden",
    "chipSearchTitle": "Chip zoeken",
    "chipPlaceholder": "Voer microchipnummer in",
    "breedOtherHint": "Aangepaste rassen kunnen alleen bij een vermissing worden toegevoegd.",
    "noResults": "Geen resultaten gevonden."
  },
  "lang": {
    "label": "Taal",
    "en": "English",
    "es": "Español",
    "pap": "Papiamento",
    "nl": "Nederlands"
  },
  "status": {
    "loading": "Laden…",
    "mapLoading": "Kaart initialiseren…",
    "error": "Er ging iets mis."
  }
}
